import { Controller } from "@hotwired/stimulus"
import { showSystemToast } from "../utils/system_toast"

// Profile-page LinkedIn refresh actions POST their selected endpoint, poll
// until it completes, and reload so the refreshed content renders.
const POLL_INTERVAL_MS = 1500
const MAX_POLLS = 12

export default class extends Controller {
    static values = {
        url: String,
        followersUrl: String,
        subject: { type: String, default: "Profile" }
    }

    refresh(e) {
        this._refresh(e, this.urlValue, this.subjectValue)
    }

    refreshFollowers(e) {
        this._refresh(e, this.followersUrlValue, "LinkedIn followers")
    }

    _refresh(e, url, subject) {
        e.preventDefault()
        if (this._busy || !url) return
        this._busy = true
        this._url = url
        this._subject = subject
        this.element.classList.add("linkedin-refresh--busy")
        fetch(this._url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""
            },
            credentials: "same-origin"
        })
            .then((response) => response.json().then((data) => ({ response, data })))
            .then(({ response, data }) => {
                if (!response.ok || !data.ok) throw new Error(data.message || `Could not refresh ${this._subject} from LinkedIn.`)
                this._since = data.since
                this._polls = 0
                this._poll()
            })
            .catch((error) => this._fail(error.message))
    }

    _poll() {
        this._polls += 1
        if (this._polls > MAX_POLLS) return this._fail("Still refreshing - check back in a minute.")
        this._timer = setTimeout(() => {
            let statusUrl = this._since ? `${this._url}?since=${encodeURIComponent(this._since)}` : this._url
            fetch(statusUrl, { headers: { Accept: "application/json" }, credentials: "same-origin" })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === "done") {
                        showSystemToast(data.message || `${this._subject} refreshed from LinkedIn.`, { level: "success", duration: 3000 })
                        setTimeout(() => {
                            if (window.Turbo) {
                                window.Turbo.visit(window.location.href, { action: "replace" })
                            } else {
                                window.location.reload()
                            }
                        }, 700)
                    } else if (data.status === "error") {
                        this._fail(data.message)
                    } else {
                        this._poll()
                    }
                })
                .catch(() => this._poll())
        }, POLL_INTERVAL_MS)
    }

    disconnect() {
        if (this._timer) clearTimeout(this._timer)
    }

    _fail(message) {
        this._busy = false
        this.element.classList.remove("linkedin-refresh--busy")
        showSystemToast(message || `Could not refresh ${this._subject || this.subjectValue} from LinkedIn.`, { level: "danger", duration: 3500 })
    }
}
